import type {CourseApiModel} from '../../../../api/course';
import type {MembershipExpandedCommon} from '../../../../api/membership';
import type {
  CoreCoachMembershipsAcceptParams,
  CoreCoachMembershipsMoveParams,
} from '../../../../api/types/core/methods';
import type {RpcRequest} from '../../../../api/utils/apiRequest';

import {apiRequest} from '../../../../api/utils/apiRequest';
import {AcceptRequestedMembershipsStrategy} from './AcceptRequestedMembershipsStrategy';

type Config = {
  memberships: MembershipExpandedCommon[];
  target: CourseApiModel;
};

export class InviteToAnotherCourseStrategy extends AcceptRequestedMembershipsStrategy {
  constructor(private readonly config: Config) {
    super();
  }

  async execute() {
    const {memberships, target} = this.config;

    const batch: RpcRequest<
      CoreCoachMembershipsAcceptParams | CoreCoachMembershipsMoveParams
    >[] = memberships.map(membership => ({
      method:
        membership.course_id === target._id
          ? 'coach.memberships.accept'
          : 'coach.memberships.move',
      params: {
        _id: membership._id,
        course_id: target._id,
      },
    }));

    await apiRequest({batch});
  }
}
